export let ReturnShippingOption;

(function (ReturnShippingOption) {
  ReturnShippingOption["Integrated"] = "integrated";
  ReturnShippingOption["Custom"] = "custom";
})(ReturnShippingOption || (ReturnShippingOption = {}));

export let ReturnShippingOptionPricing;

(function (ReturnShippingOptionPricing) {
  ReturnShippingOptionPricing["RefundSubtotal"] = "refund_subtotal";
  ReturnShippingOptionPricing["Postage"] = "postage";
  ReturnShippingOptionPricing["RefundTotal"] = "refund_total";
})(ReturnShippingOptionPricing || (ReturnShippingOptionPricing = {}));

export let ReturnShippingMethod;

(function (ReturnShippingMethod) {
  ReturnShippingMethod["Custom"] = "custom";
  ReturnShippingMethod["Integrated"] = "integrated";
})(ReturnShippingMethod || (ReturnShippingMethod = {}));

export let ReturnShippingMethodPayingSide;

(function (ReturnShippingMethodPayingSide) {
  ReturnShippingMethodPayingSide["Seller"] = "seller_pays";
  ReturnShippingMethodPayingSide["Buyer"] = "buyer_pays";
})(ReturnShippingMethodPayingSide || (ReturnShippingMethodPayingSide = {}));

export let ReturnShippingModal;

(function (ReturnShippingModal) {
  ReturnShippingModal["ReturnCurrencyConversionModal"] = "return_currency_conversion_modal";
  ReturnShippingModal["RequestReturnModal"] = "request_return_modal";
  ReturnShippingModal["None"] = "none";
})(ReturnShippingModal || (ReturnShippingModal = {}));